import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { ErrorMessage, Field } from "formik";
import TextError from "../TextError";
import useFormikSelect from "./useFormikSelect";
import FormikControlContext from "../../../Contexts/FormikControlContext";
import CustomInfoTooltip from "../CustomInfoTooltip/CustomInfoTooltip";

const FormikSelect = () => {
  const field = useContext(FormikControlContext);
  const { label, name, validation, readOnly, options, infoText, hintText } =
    field;

  const { handleChange, handleBlur, validate } = useFormikSelect();

  return (
    <>
      <Typography>
        <Box display="flex" alignItems="center" component="span">
          {label}
          {validation?.required && <span>*</span>}
          {infoText && <CustomInfoTooltip message={infoText} />}
        </Box>
      </Typography>
      <Field
        as="select"
        name={name}
        id={name}
        className="form-select form-select-lg mb-3"
        placeholder={hintText || label}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={Boolean(readOnly)}
        required={validation?.required ?? false}
        validate={validate}
      >
        {options?.length > 0 &&
          options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </>
  );
};

export default FormikSelect;
